import React, { ReactNode, useContext } from 'react'
import { useCreateChatClient, Chat as ChatClient, ChatContext } from 'stream-chat-react'
import { PageLoading } from '@/components'
import { APIClient } from '@/services'
import { Chat } from '@/config'

export const ChatProvider = ({ children }: React.PropsWithChildren) => {
  const user = Chat.Store.useUser()
  const { profile, loginResolved } = APIClient.Session.useSession()
  const sessionMode = APIClient.Session.useSessionMode()
  const clientConfig = Chat.Hooks.useClientConfig({
    enabled: loginResolved && !!profile?.id && sessionMode.loaded,
  })

  const profileUnresolved = !user?.id || !profile?.id
  const clientLoading = !clientConfig?.tokenOrProvider

  if (profileUnresolved || clientLoading || !loginResolved) return <>{children}</>

  return <ChatWrapper clientConfig={clientConfig}>{children}</ChatWrapper>
}

const ChatWrapper = ({
  clientConfig,
  children,
}: {
  clientConfig: any
  children: ReactNode
}) => {
  const client = useCreateChatClient(clientConfig)

  if (!client) return <PageLoading />

  return (
    <ChatClient client={client}>
      {children}
    </ChatClient>
  )
}

export const ChatProviderGate = (props: React.PropsWithChildren) => {
  const user = Chat.Store.useUser()
  const { profile, loginResolved } = APIClient.Session.useSession()

  const ctx = useContext(ChatContext)

  const profileUnresolved = !user?.id || !profile?.id
  const clientLoading = !ctx

  const loading = profileUnresolved || clientLoading || !loginResolved

  if (loading) return null

  return <>{props.children}</>
}
